module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-1-c17d0e64d222f62f5c6681d239303725.webp";